import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cn } from '../../utils/cn';

export const DrawerTitle = React.forwardRef<
    React.ElementRef<typeof DrawerPrimitive.Title>,
    React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Title>
>(({ className, ...props }, ref) => {
    return (
        <DrawerPrimitive.Title
            ref={ref}
            data-slot="drawer-title"
            className={cn('text-xl text-foreground', className)}
            {...props}
        />
    );
});

DrawerTitle.displayName = DrawerPrimitive.Title.displayName;
